"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapeUtilities = void 0;
const Point_1 = require("../../graphics2d/Point");
const Point2D_1 = require("../../graphics2d/Point2D");
const Rectangle2D_1 = require("../../graphics2d/Rectangle2D");
const path_1 = require("../shapes/path");
/**
 *
 *
 */
class ShapeUtilities {
    static grow(rect, size) {
        rect.setRect(rect.getX() - size, rect.getY() - size, rect.getWidth() + (size * 2), rect.getHeight() + (size * 2));
    }
    static offset(...args) {
        if (args.length === 3) {
            if (args[0] instanceof Rectangle2D_1.Rectangle2D) {
                const [rect, offsetX, offsetY] = args;
                rect.setRect(rect.getX() + offsetX, rect.getY() + offsetY, rect.getWidth(), rect.getHeight());
            }
            else if (args[0] instanceof Point2D_1.Point2D) {
                const [point, offsetX, offsetY] = args;
                point.setLocation(point.getX() + offsetX, point.getY() + offsetY);
            }
            else if (args[0] instanceof Point_1.Point) {
                const [point, offsetX, offsetY] = args;
                point.setLocation(point.getX() + offsetX, point.getY() + offsetY);
            }
            else if (args[0] instanceof path_1.Path) {
                console.log("ShapeUtilities.offset - Can't offset Path");
            }
            else if (args[0] instanceof Path2D) {
                console.log("ShapeUtilities.offset - Can't offset Path2D");
            }
        }
    }
}
exports.ShapeUtilities = ShapeUtilities;
//# sourceMappingURL=ShapeUtilities.js.map